import React, { useEffect, useRef } from 'react';
import Image from 'next/image';
import CustomButton from './CustomButton';
import { useAuthTokens } from '@/utils/tokenHelper';

interface LoginModalProps {
  onLogin?: () => void;
}

const LoginModal: React.FC<LoginModalProps> = ({ onLogin }) => {
  const modalRef = useRef<HTMLDialogElement>(null);
  const { accessToken, refreshToken } = useAuthTokens();
  const isLoggedIn = !!accessToken && !!refreshToken;

  // Close modal if user becomes logged in
  useEffect(() => {
    if (isLoggedIn && modalRef.current) {
      modalRef.current.close();
    }
  }, [isLoggedIn]);

  // Open modal when component mounts (parent controls rendering via isChatLoginRequired)
  useEffect(() => {
    if (modalRef.current) {
      modalRef.current.showModal();
    }
  }, []);

  return (
    <dialog ref={modalRef} className='modal modal-open'>
      <div className='modal-box'>
        <div className='flex flex-col items-center'>
          <Image
            className='mb-3.5'
            src='/assets/images/logo-2.svg'
            alt='Nexgo Logo'
            width={36}
            height={40}
            priority
          />
          <h5 className='text-xl leading-10 font-normal text-center capitalize'>
            Log into Nexgo to continue
          </h5>
        </div>

        <div className='modal-action mt-0 justify-center'>
          <CustomButton
            label='Continue with Google'
            type='button'
            className='xs:w-[22.5rem] w-[18rem] mt-6 mb-2.5'
            variant='secondary'
            src='/assets/images/svg/google.svg'
            onClick={onLogin}
          />
        </div>

        <div className='flex gap-2 w-full justify-center items-center text-[10px] leading-[14px] pt-[19px] text-grey'>
          <span className='text-black'>•</span>
          <a href='#'>Privacy Policy</a>
          <span className='text-black'>•</span>
          <a href='#'>Terms & conditions</a>
        </div>
      </div>
    </dialog>
  );
};

export default LoginModal;
